import { RefDataType } from 'scenes/common/types';
import { SpecifiedContentCover } from 'scenes/home/types';

// A hack fix for CDIGITAl-404. Pega should update to
// give us clean list of options.
export const filterOptions = (
  contentsType: SpecifiedContentCover,
  options: RefDataType[]
): RefDataType[] => {
  if (contentsType === SpecifiedContentCover.PortableContents) {
    return options.filter(
      (element) =>
        element.label !== 'Artwork & Antiques' &&
        element.label !== 'Collections'
    );
  }

  return options;
};
